import React, { useContext, useEffect } from 'react'
import { PageNumberContext } from './PageNumberContext'
import ChooseTypeCard from './ChooseTypeCard'
import { Field, useForm, useFormState } from 'react-final-form'
import { Box, TextField, Typography } from '@mui/material'
import GenericSelect from '../../../common/components/GenericSelect'
import { campaignTriggerOptions, messagesType, timelineOptions } from './utils'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { parseJwt } from 'src/heplers'

export default function SecondPageForOtherStepsForm() {
  const { values } = useFormState()
  const form = useForm()
  const { setPage } = useContext(PageNumberContext)
  const isSmsTemplate = values?.metadata?.phoneNumber
  const isSlack = values?.type === 'SLACK'
  const emailTemplatesCount = isNaN(
    (values?.internalTemplateIds?.length || 0) + (values?.customTemplateIds?.length || 0)
  )
    ? 0
    : (values?.internalTemplateIds?.length || 0) + (values?.customTemplateIds?.length || 0)

  const cardMapper = {
    AUTOMATED_EMAIL: {
      type: 'AUTOMATED_EMAIL',
      title: 'Auto-Selected Email Template',
      description: 'AI selects the best existing template from our database based on previous user simulation results',
      isAI: true,
      onChange: () => setPage(1)
    },
    MANUAL_EMAIL: {
      type: 'MANUAL_EMAIL',
      title: 'Custom Email',
      description: 'Choose a template or create a phishing email manually from scratch',
      isAI: false,
      onChange: () => setPage(1)
    },
    AUTOMATED_AI_EMAIL: {
      type: 'AUTOMATED_AI_EMAIL',
      title: 'Fully AI-Generated Email',
      description: 'AI writes a phishing email from scratch based on past user mistakes and tools used in your company',
      isAI: true,
      onChange: () => setPage(1)
    },
    SMS: {
      type: 'SMS',
      title: 'SMS Message',
      description: 'Send a phishing test message as a text to mobile phones',
      isAI: false,
      onChange: () => setPage(1)
    },
    WHATSAPP: {
      type: 'WHATSAPP',
      title: 'Whatsapp Message',
      description: 'Send a phishing test message to selected users via WhatsApp',
      isAI: false,
      onChange: () => setPage(1)
    },
    SLACK: {
      type: 'SLACK',
      title: 'Slack Message',
      description: 'Send a phishing test message to selected users via Slack',
      isAI: false,
      onChange: () => setPage(1)
    },
    DEEP_FAKE: {
      type: 'DEEP_FAKE',
      title: 'Deepfake Call (AI-Generated)',
      description: 'Send a simulated phone call using a bot with an AI-generated voice and script',
      isAI: false,
      onChange: () => setPage(1),
      isDisabled: false
    },
    DEEP_FAKE_TEMPLATE: {
      type: 'DEEP_FAKE_TEMPLATE',
      title: 'Template',
      description: '',
      number: values?.metadata?.callerName && 1,
      isAI: false,
      onChange: () => setPage('DEEP_FAKE_TEMPLATE'),
      isDisabled: false
    },
    AUTOMATED_AI_EMAIL_TEMPLATE: {
      type: 'AUTOMATED_AI_EMAIL_TEMPLATE',
      title: 'Template',
      description: '',
      number: values?.metadata?.services?.length && 1,
      isAI: false,
      onChange: () => setPage('AUTOMATED_AI_EMAIL_TEMPLATE'),
      isDisabled: false
    },
    SMS_TEMPLATE: {
      type: 'SMS_TEMPLATE',
      title: 'Template',
      description: '',
      isAI: false,
      onChange: () => {
        setPage('SMS_TEMPLATE')
      },
      number: isSmsTemplate && 1,
      isDisabled: false
    },
    SLACK_TEMPLATE: {
      type: 'SLACK_TEMPLATE',
      title: 'Template',
      description: '',
      isAI: false,
      number: values?.metadata?.message && 1,
      onChange: () => {
        setPage('SLACK_TEMPLATE')
      }
    },
    EMAIL_TEMPLATE: {
      type: 'EMAIL_TEMPLATE',
      title: 'Template',
      description: '',
      isAI: false,
      onChange: () => {
        setPage('EMAIL_TEMPLATE')
      },
      number: emailTemplatesCount,
      isDisabled: false
    }
  }
  useEffect(() => {
    if (values?.timeline !== 'CUSTOM_DAYS_COUNT') {
      form.change('daysCount', null)
    }
    if (values?.timeline !== 'CUSTOM_DATE') {
      form.change('startDate', null)
    }
  }, [values?.timeline])

  useEffect(() => {
    if (values?.timeline === 'CUSTOM_DATE' && !values?.startDate) {
      form.change('startDate', dayjs().format('YYYY-MM-DD'))
    }
  }, [values?.timeline])

  const userLocal = JSON.parse(localStorage.getItem('user'))
  const companyId = parseJwt(userLocal?.accessToken).companyId
  const mediIds = [
    '2ffd7fc7-6d0f-48b6-94c2-1aab115f1ae8', //local
    'a0f656e2-47ae-4022-85f6-208043644228',
    'c651ad24-8329-4181-9865-d3a99ffd6668',
    '67416a7e-e2af-464f-968a-390e7d17c1a8',
    'ab09d00b-c34d-4d1b-90c8-a5c830add241',
    '6cc805ed-85fe-4f3b-b2f2-f06b19d211e9'
  ]
  const isMediId = mediIds.includes(companyId)

  return (
    <Box display={'flex'} flexDirection={'column'} rowGap={3}>
      <ChooseTypeCard {...cardMapper[values?.type]} />
      {isSlack && <ChooseTypeCard {...cardMapper['SLACK_TEMPLATE']} />}
      {messagesType.includes(values?.type) && <ChooseTypeCard {...cardMapper['SMS_TEMPLATE']} />}
      {values?.type === 'MANUAL_EMAIL' && <ChooseTypeCard {...cardMapper['EMAIL_TEMPLATE']} />}
      {values?.type === 'DEEP_FAKE' && <ChooseTypeCard {...cardMapper['DEEP_FAKE_TEMPLATE']} />}
      {values?.type === 'AUTOMATED_AI_EMAIL' && <ChooseTypeCard {...cardMapper['AUTOMATED_AI_EMAIL_TEMPLATE']} />}
      <Box display={'flex'} flexDirection={'column'} columnGap={1} gap={2}>
        <Typography color={'#76767F'} fontWeight={500} fontSize={'16px'} fontFamily={'Plus Jakarta Sans'}>
          Choose event & timing
        </Typography>
        <Box display={'flex'} columnGap={2}>
          <Field
            name={'triggerAction'}
            render={({ input }) => (
              <GenericSelect
                label={'Event'}
                options={campaignTriggerOptions}
                value={input.value}
                onChange={input.onChange}
              />
            )}
          />
          <Field
            name={'timeline'}
            render={({ input, meta }) => (
              <GenericSelect
                label={'Timing'}
                options={
                  isMediId && values.type == 'DEEP_FAKE'
                    ? timelineOptions.filter(el => el.value !== 'IMMEDIATELY')
                    : timelineOptions
                }
                value={input.value}
                onChange={value => {
                  input.onChange(value)
                  if (values?.timeline !== 'CUSTOM_DATE' && values?.timeline !== 'CUSTOM_DAYS_COUNT') {
                    meta?.form?.change('startDate', null)
                  }
                }}
              />
            )}
          />
          {values?.timeline === 'CUSTOM_DATE' && (
            <Field
              name={'startDate'}
              render={({ input, meta }) => {
                return (
                  <DatePicker
                    format={'DD/MM/YYYY'}
                    disablePast={true}
                    minDate={dayjs()}
                    sx={{
                      width: 240,
                      marginRight: '20px',
                      backgroundColor: '#ffffff',
                      '& .MuiOutlinedInput-root': {
                        fontSize: 16,
                        fontWeight: 400,
                        fontFamily: 'Plus Jakarta Sans',
                        borderRadius: '10px'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '12.5px 14px'
                      }
                    }}
                    slotProps={{
                      textField: {
                        error: meta.touched && meta.error
                      },
                      inputAdornment: { position: 'start', variant: 'standard' }
                    }}
                    onChangeRaw={e => e.preventDefault()}
                    shouldDisableDate={date => date.isBefore(dayjs(), 'day')}
                    value={dayjs(input.value)}
                    label='Start Date'
                    onChange={date => {
                      const selectedDate = dayjs(date)
                      if (selectedDate.isBefore(dayjs(), 'day')) {
                        input.onChange(dayjs().format('YYYY-MM-DD'))
                      } else {
                        input.onChange(selectedDate.format('YYYY-MM-DD'))
                      }
                    }}
                  />
                )
              }}
            />
          )}
          {values?.timeline === 'CUSTOM_DAYS_COUNT' && (
            <Field
              name={'daysCount'}
              render={({ input }) => (
                <TextField
                  label={'Days Count'}
                  type={'number'}
                  sx={{
                    width: 240,
                    marginRight: '20px',
                    backgroundColor: '#ffffff',
                    '& .MuiOutlinedInput-root': {
                      fontSize: 16,
                      fontWeight: 400,
                      fontFamily: 'Plus Jakarta Sans',
                      borderRadius: '10px'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '12.5px 14px'
                    }
                  }}
                  value={input.value}
                  onChange={input.onChange}
                />
              )}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
